export interface DataListComplexFormulaFieldModel {
  label: string;
  id: number;
  x: number;
  y: number;
  cols: number;
  rows: number;
}
